import ContactCentered from "./ContactCentered";
import ContentFeatureBox from "./Content/ContentFeatureBox";
import ContentFeatureList from "./Content/ContentFeatureList";
import ContentText from "./Content/ContentText";
import LogosSimple from "./Content/LogosSimple";
import FooterDefault from "./Footer/FooterDefault";
import CardWithBackgroundImage from "./Header/CardWithBackgroundImage";
import HeroHeaderBackground from "./Header/HeroHeaderBackground";
import HeroHeader from "./HeroHeader";
import NavbarDefault from "./Navbar/NavbarDefault";
import RepeatableCenteredAccordion from "./Repeatable/RepeatableCenteredAccordion";
import TextImage from "./TextImage";
const elements = {
    "hero-header": HeroHeader,
    "text-image": TextImage,
    "navbar-default": NavbarDefault,
    "footer-default": FooterDefault,
    "contact-centered": ContactCentered,
    "header-card-with-background-image": CardWithBackgroundImage,
    "content-feature-list": ContentFeatureList,
    "content-feature-box": ContentFeatureBox,
    "content-text": ContentText,
    "content-logos-simple": LogosSimple,
    "header-heroheader-background": HeroHeaderBackground,
    "repeatable-repeatable-centered-accordion": RepeatableCenteredAccordion,
};
export default elements;
//# sourceMappingURL=index.js.map